














import { Vue, Component, Prop } from "vue-property-decorator";
import TextInput, { InputType } from "@/basics/inputs/TextInput.vue";
import CSelect, { SelectOption } from "@/basics/selects/CSelect.vue";
import DatetimePicker from "@/basics/inputs/DateTimePicker.vue";
import LabelTitle from "@/basics/inputs/LabelTitle.vue";

@Component({
  components: {
    TextInput,
    CSelect,
    DatetimePicker,
    LabelTitle
  }
})
export default class LabelInputDate extends Vue {
  @Prop({ type: Object, required: true }) value!: { start: Date; end: Date };
}
